import { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { GoCheck } from 'react-icons/go';
import { ACTIVE_NETWORKS, ChainId, NETWORK_LOGOS } from '@shared/utils/config/networks';
import { networkNames } from '@shared/types/executor';
import ImageWithFallback from './ImageWithFallback';
import SlidingModal from '../home/mobile/SlidingModal';
import { getNetworkLogo } from '@/lib/misc/tokenImageHelper';
import classNames from '@/lib/misc/classNames';
import CustomDialog from '../ui/customDialog';
export default function NetworkDropdown({
  shortAll,
  setNetwork,
  network,
  defaultNetwork,
  isMobile = true,
  isPortfolio,
  className,
  textBlack = false,
  modalZIndex
}: {
  shortAll?: boolean;
  setNetwork: (_: number[]) => void;
  network: number[];
  defaultNetwork: number[];
  isMobile?: boolean;
  isPortfolio?: boolean;
  className?: string;
  textBlack?: boolean;
  modalZIndex?: number;
}) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  function toggleOpenModal() {
    setOpenModal(!openModal);
  }
  const networks = [{
    networkName: 'All Networks',
    chainId: 'all-networks',
    networkLogo: '/static/genius.png'
  }, ...ACTIVE_NETWORKS.map(x => ({
    networkName: ChainId[x] || 'All Networks',
    chainId: x,
    networkLogo: NETWORK_LOGOS[x] || '/static/images/defaultnetwork.png'
  }))];
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const ModalContent = () => {
    return <div data-sentry-component="ModalContent" data-sentry-source-file="NetworkDropdown.tsx">
        <ul className='w-full'>
          {networks.map(networkItem => <li key={networkItem.chainId} className='px-4 cursor-pointer lg:hover:bg-genius-blue flex justify-between items-center py-3 border-genius-blue text-genius-cream' onClick={() => {
          setNetwork(networkItem.networkName === 'All Networks' ? defaultNetwork : [Number(networkItem.chainId)]);
          toggleModal();
          setOpenModal(false);
        }}>
              <div className='flex items-center w-3/5'>
                <ImageWithFallback src={networkItem.networkLogo} width={24} height={24} alt={`${networkItem.networkName} logo`} className='mr-4' />
                <span className='capitalize'>
                  {networkItem.networkName.replace('-mainnet', '')}
                </span>
                {network[0] === networkItem.chainId && network.length === 1 ? <GoCheck className='h-4 w-4 ml-4' /> : network.length > 1 && networkItem.networkName === 'All Networks' ? <GoCheck className='h-4 w-4 ml-4' /> : ''}
              </div>
            </li>)}
        </ul>
      </div>;
  };
  const NetworkTrigger = () => {
    return <div onClick={isMobile ? toggleModal : toggleOpenModal} className={classNames('font-light w-full cursor-pointer flex items-center text-[12px] justify-start whitespace-nowrap	', className)} data-sentry-component="NetworkTrigger" data-sentry-source-file="NetworkDropdown.tsx">
        <ImageWithFallback src={network.length > 1 ? textBlack ? '/static/icons/dark-genius.png' : '/static/genius.png' : getNetworkLogo(network[0])} width={shortAll ? 16 : 15} height={shortAll ? 16 : 15} alt={'logo'} className={'mr-2'} data-sentry-element="ImageWithFallback" data-sentry-source-file="NetworkDropdown.tsx" />

        {network.length > 1 ? isPortfolio ? 'All Networks' : 'All Networks' : networkNames[network[0]] === 'Binance Smart Chain' ? 'Binance' : networkNames[network[0]]}

        <IoIosArrowDown className='h-4 w-4 ml-3' data-sentry-element="IoIosArrowDown" data-sentry-source-file="NetworkDropdown.tsx" />
      </div>;
  };
  return <div className={`w-full ${textBlack ? 'text-genius-blue bg-genius-pink' : ' text-genius-cream'}`} data-sentry-component="NetworkDropdown" data-sentry-source-file="NetworkDropdown.tsx">
      {!isMobile ? <>
          <NetworkTrigger />
          <CustomDialog hideClose={true} toggleModal={toggleOpenModal} isOpen={openModal} className={'h-[497px] w-[400px] px-0 pt-2'}>
            <ModalContent />
          </CustomDialog>
        </> : <>
          <div className={`w-full flex  ${textBlack ? 'bg-genius-pink' : ''}`}>
            <NetworkTrigger />
          </div>
          <SlidingModal heightFit isOpen={isModalOpen} onClose={toggleModal} modalZIndex={modalZIndex}>
            <ModalContent />
          </SlidingModal>
        </>}
    </div>;
}